import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Partner } from '../models';

export interface SelectedPartnerState {
  selectedPartner: Partner | null;
}

const initialState: SelectedPartnerState = {
  selectedPartner: null,
};

export const SelectedPartnerStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setSelectedPartner(selectedPartner: Partner | null): void {
      patchState(store, { selectedPartner });
    },
  })),
);
